import React, { useState } from 'react';
import Button from "react-bootstrap/Button";

import { loginRequest/*, msalConfig*/ } from './office365auth/authConfig';
import { callMsGraph } from './office365auth/graph';

import { useMsal } from '@azure/msal-react';

import { SignOutButton } from './office365auth/SignOutButton';
import { useEffect } from 'react';
import Buscar from './Buscar';
import Formato from './Formato';

import { createAPIEndpoint } from '../api/index'
import { ENDPOINTS } from '../api/config'
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";

import SeleccionarPlanAcademico from './SeleccionPlanAcademico';
import ErrorModal, { useErrorHandling } from './ErrorModal';
import Spinner from './Spinner';
import Plantilla from './plantillas/Plantilla'

import { populateStudentMetadata, saveMsToken} from '../helper/studentMetadata';
import { isUserFromApp } from '../api/index';

export default function Home() {

    const flowSteps = {
        home: 0,
        selectPlan: 1,
        format: 2,
        noData: 3,
        noAllowed: 4
    };

    const { instance, accounts } = useMsal();
    const [graphData, setGraphData] = useState(null);
    const [employeeId, setEmployeeId] = useState(null);
    const [studentInfo, setStudentInfo] = useState(null);
    const [employeeInfo, setEmployeeInfo] = useState(null);
    const [stepIndex, setStepIndex] = useState(flowSteps.home);

    const [selectedPlan, setSelectedPlan] = useState(null);

    const { error, clearError, showErrorModal } = useErrorHandling('PA001');

    const [showSpinner, setShowSpinner] = useState(false);

    useEffect(() => {
        if (studentInfo) {
            if (studentInfo.aPaterno.length > 0) {

                let grados = studentInfo.grados.filter(g => employeeInfo.some(c => c.Clave === g.campusKey));

                if (grados.length === 0) {
                    setStepIndex(flowSteps.noAllowed);
                    return;
                }

                studentInfo.grados = grados;

                populateStudentMetadata(studentInfo, selectedPlan);

                if (studentInfo.grados.length > 1 && !selectedPlan) {
                    setStepIndex(flowSteps.selectPlan);
                }
                else {
                    if(!selectedPlan)
                        setSelectedPlan(studentInfo.grados[0].programaKey);

                    setStepIndex(flowSteps.format);
                }
            }
            else {
                setStepIndex(flowSteps.noData);
            }
        }
    }, [studentInfo, selectedPlan]);

    function RequestProfileData() {

        if (isUserFromApp()) {
            createAPIEndpoint(ENDPOINTS.getMe)
                .fetch()
                .then(res => {
                    setGraphData(res.data);
                })
                .catch(err => {
                    if (err.response.status === 401) {
                        saveMsToken(null);
                        window.location = "/";
                        return;
                    }

                    showErrorModal(null, error.serie, '001');
                })
                .finally(() => {
                    setStudentInfo(null);
                    GetEmployeeInfo(employeeId, null);
                    setShowSpinner(false);
                });

            return;
        }

        // Silently acquires an access token which is then attached to a request for MS Graph data
        instance
            .acquireTokenSilent({
                ...loginRequest,
                account: accounts[0],
            })
            .then((response) => {
                saveMsToken(response.accessToken);
                callMsGraph(response.accessToken).then((response) => setGraphData(response));
            });
    }
    function ProcessFlow() {
        const handleOnContinue = (planAcademico) => setTimeout(() => {
            setSelectedPlan(planAcademico)
        }, 0);

        const handleOnCancelar = () => setTimeout(() => {
            setStudentInfo(null);
            setSelectedPlan(null);
            setStepIndex(flowSteps.home);
        }, 0);

        switch (stepIndex) {
            case flowSteps.home:
                return (
                    <>
                        <Buscar onUpdateStudentInfo={(studentInfo) => { setStudentInfo(studentInfo) }} />
                    </>);
            case flowSteps.selectPlan:
                return (
                    <>
                        <SeleccionarPlanAcademico studentInfo={studentInfo} onContinuar={handleOnContinue} onCancelar={handleOnCancelar} />
                    </>);
            case flowSteps.format:
                return (
                    <>
                        <Formato studentInfo={studentInfo} programa={selectedPlan} onCancelar={handleOnCancelar} />
                    </>);
            case flowSteps.noData:
                return (
                    <>
                        <Mensaje titulo="Matricula no encontrada" mensaje="La matricula que buscaste no fue encontrada." onCancelar={handleOnCancelar} />
                    </>);
            case flowSteps.noAllowed:
                return (
                    <>
                        <Mensaje titulo="Campus no permitido" mensaje="La matricula que buscaste pertenece a un campus al cual no tienes acceso." onCancelar={handleOnCancelar} />
                    </>);
            default:
                return (
                    <>
                        <NoCandidato/>
                    </>);
            }
        }

    useEffect(() => {
        RequestProfileData();
    }, []);

    useEffect(() => {
        if (!graphData) return;
        let employee = graphData.userPrincipalName;

        setEmployeeId(employee)

        setStudentInfo(null);
        GetEmployeeInfo(employee, null);

    }, [graphData]);
    function GetEmployeeInfo(employee) {
        setShowSpinner(true);

        createAPIEndpoint(ENDPOINTS.getCampusEmployee)
            .fetchById(employee)
            .then(res => {
                setEmployeeInfo(res.data);
                setStepIndex(flowSteps.home);
            })
            .catch(err => {
                showErrorModal(err, error.serie, '');
            })
            .finally(() => {
                setShowSpinner(false);
            });
    }

    return (<>
        <Spinner show={showSpinner} />
        <ProcessFlow />
        <ErrorModal error={error} onClose={clearError} />
    </>)
};

const NoCandidato = (props) => {
    if (!props.open) return null;

    return (<>
        <Plantilla id="NoCandidato"></Plantilla>

        <Row>
            <Col className="d-grid gap-2 mt-4">
                <SignOutButton />
            </Col>
        </Row>

    </>);
};

const Mensaje = (props) => {
    return (<>
        <Container>
            <Row>
                <Col>
                    <p>{props.titulo}</p>
                </Col>
            </Row>
            <Row>
                <Col>
                    <p className="blue-label">
                        {props.mensaje}
                    </p>
                </Col>
            </Row>
            <Row>
                <Col className="d-grid gap-2 mt-5 mb-2">
                    <Button variant="primary" onClick={() => props.onCancelar()}>
                        Regresar
                    </Button>
                </Col>
            </Row>
        </Container>
    </>);
};